import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { PasswordService } from '@renovationman/rm-uaa-api-client-ts-ng20';

import { ORIGIN_URL_QUERY_PARAM_KEY } from 'libs/auth-lib/src/public-api';
import { finalize, first } from 'rxjs/operators';

import { FIRST_LOGIN_QUERY_PARAM_KEY } from '~constants';

@Component({
  templateUrl: './forgotten-password.page.html',
  standalone: false,
})
export class ForgottenPasswordPage implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private passwordService: PasswordService
  ) {}

  submitted = false;
  submitting = false;

  formSent = false;
  expiredLink = false;
  firstLogin = false;
  originUrl: string;

  emailControl = new FormControl<string | null>(null, [
    Validators.email,
    Validators.required,
  ]);

  ngOnInit() {
    this.route.data.pipe(first()).subscribe((data) => {
      this.expiredLink = !!data.expiredLink;
    });
    this.route.queryParamMap.pipe(first()).subscribe((params) => {
      this.firstLogin = !!params.get(FIRST_LOGIN_QUERY_PARAM_KEY);
      this.originUrl = params.get(ORIGIN_URL_QUERY_PARAM_KEY);
    });
  }

  get contentTranslateKey() {
    if (this.formSent) {
      return this.firstLogin ? 'FIRST_CONNECTION_SUCCESS' : 'NORMAL_SUCCESS';
    }
    return this.expiredLink
      ? this.firstLogin
        ? 'EXPIRED_LINK_FIRST_CONNECTION'
        : 'EXPIRED_LINK'
      : 'NORMAL';
  }

  get iconFileName() {
    if (this.formSent) {
      return 'forgotten-password-success';
    }
    return this.expiredLink ? 'expired-link' : 'forgotten-password';
  }

  submit() {
    this.submitted = true;
    if (!this.emailControl.valid) {
      return;
    }
    this.submitting = true;
    this.formSent = true;
    this.passwordService
      .requestPasswordUpdateLink({
        email: this.emailControl.value,
        originUrl: this.originUrl ? this.originUrl : undefined,
      })
      .pipe(finalize(() => (this.submitting = false)))
      .subscribe();
  }
}
